fragment SupplierControlPanelProductSharedTranslatorFragment on SupplierControlPanelProductSharedTranslator {
    id
    updated
    has_empty_columns
    field_name
    original_text_en
    original_text_sv
    translations
}